module.exports = __webpack_public_path__ + "static/media/image-6.fe77f906.jpg";